import React from 'react';
import { useTabs, TabBar } from './TabManager';
import { useVbMenu, tabButtonOn } from '../utils/vbPerms';
import CarKinds from './Tadarokat/CarKinds';
import HazinehDocument from './Tadarokat/HazinehDocument';
import DepartmentList from './Income/DepartmentList';
import Place from './Tadarokat/Place';
import GoodsRequest from './Tadarokat/GoodsRequest';
import Stock from './Tadarokat/Stock';
import CityList from './Income/CityList';
import Goods from './Tadarokat/Goods';
import AmountReceivers from './Tadarokat/AmountReceivers';
import PropertyPage from './Tadarokat/PropertyPage';
import Cars from './Tadarokat/Cars';
import GoodsGroup from './Tadarokat/GoodsGroup';
import Buildings from './Tadarokat/Buildings';
import BankBranch from './Tadarokat/BankBranch';
import FlightTicket from './Tadarokat/FlightTicket';
import CarMission from './Tadarokat/CarMission';

/* دکمه‌های منوی «تدارکات» — key همان کلید مجوز در تب TBTADAROKAT است */
const TADAROKAT_BUTTONS = [
  { key: 'btnCarKinds',         label: 'انواع خودرو',                icon: '🚙', bg: 'linear-gradient(135deg,#37474f,#546e7a)', page: 'car_kinds' },
  { key: 'btnHazineDocument0',  label: 'تنظیم سند هزینه جاری',       icon: '🧾', bg: 'linear-gradient(135deg,#1a237e,#283593)', page: 'hazineh0' },
  { key: 'btnHazineDocument1',  label: 'تنظیم سند هزینه سرمایه ای',  icon: '📑', bg: 'linear-gradient(135deg,#311b92,#4527a0)', page: 'hazineh1' },
  { key: 'btnDepartments2',     label: 'واحدهای اجرایی',             icon: '🏢', bg: 'linear-gradient(135deg,#1b5e20,#2e7d32)', page: 'departments' },
  { key: 'btnPlace',            label: 'اماکن',                      icon: '🏠', bg: 'linear-gradient(135deg,#004d40,#00695c)', page: 'place' },
  { key: 'btnGoodsRequest',     label: 'درخواست خرید کالا',          icon: '🛒', bg: 'linear-gradient(135deg,#e65100,#ef6c00)', page: 'goods_request' },
  { key: 'btnStock',            label: 'معرفی انبارها',              icon: '🏬', bg: 'linear-gradient(135deg,#4e342e,#6d4c41)', page: 'stock' },
  { key: 'btnCities1',          label: 'شهرها',                      icon: '🏙️', bg: 'linear-gradient(135deg,#01579b,#0277bd)', page: 'cities' },
  { key: 'btnGoods',            label: 'معرفی کالا و خدمات',         icon: '📦', bg: 'linear-gradient(135deg,#bf360c,#d84315)', page: 'goods' },
  { key: 'btnAmountReceivers1', label: 'گیرندگان وجه',               icon: '👥', bg: 'linear-gradient(135deg,#880e4f,#ad1457)', page: 'amount_receivers' },
  { key: 'btnProperty',         label: 'اموال و کالاهای مصرفی',      icon: '🗄️', bg: 'linear-gradient(135deg,#33691e,#558b2f)', page: 'property1' },
  { key: 'btnCars',             label: 'وسایط نقلیه',                icon: '🚗', bg: 'linear-gradient(135deg,#263238,#37474f)', page: 'cars' },
  { key: 'btnGoodsGroup',       label: 'معرفی گروه کالا و خدمات',    icon: '🗂️', bg: 'linear-gradient(135deg,#827717,#9e9d24)', page: 'goods_group' },
  { key: 'btnBuildings',        label: 'ساختمان ها',                 icon: '🏛️', bg: 'linear-gradient(135deg,#3e2723,#5d4037)', page: 'buildings' },
  { key: 'btnProperty2',        label: 'کالاهای مصرفی',              icon: '🧺', bg: 'linear-gradient(135deg,#558b2f,#689f38)', page: 'property2' },
  { key: 'btnBankBranch1',      label: 'شعبات بانکها',               icon: '🏦', bg: 'linear-gradient(135deg,#0d47a1,#1565c0)', page: 'bank_branch' },
  { key: 'btnFlightTicket',     label: 'هزینه بلیط ماموریت',         icon: '✈️', bg: 'linear-gradient(135deg,#006064,#00838f)', page: 'flight_ticket' },
  { key: 'btnCarMission',      label: 'مأموریت خودرو',              icon: '🚐', bg: 'linear-gradient(135deg,#1b5e20,#388e3c)', page: 'car_mission' },
];

const PAGE_COMPONENTS = {
  car_kinds: CarKinds,
  hazineh0: (p) => <HazinehDocument {...p} programKind={0} />,
  hazineh1: (p) => <HazinehDocument {...p} programKind={1} />,
  departments: DepartmentList,
  goods_request: GoodsRequest,
  stock: Stock,
  cities: CityList,
  goods: Goods,
  amount_receivers: AmountReceivers,
  property1: (p) => <PropertyPage {...p} variant={1} />,
  property2: (p) => <PropertyPage {...p} variant={2} />,
  cars: Cars,
  goods_group: GoodsGroup,
  buildings: Buildings,
  bank_branch: BankBranch,
  flight_ticket: FlightTicket,
  car_mission: CarMission,
};

export default function Tadarokat({ user, onBack }) {
  const { openTab, goHome } = useTabs();

  // دابل‌کلیک روی اموال در صفحهٔ اماکن ← صفحهٔ اموال با همان ردیف
  const openProperty = (row) => openTab('tadarokat:property1', 'اموال و کالاهای مصرفی', '🗄️',
    () => <PropertyPage user={user} onBack={goHome} variant={1} preset={{ propertyId: row && (row.property_id || row.id) }} />);

  const openSubPage = (btn) => {
    if (btn.page === 'place') {
      openTab('tadarokat:place', btn.label, btn.icon, () => <Place user={user} onBack={goHome} onOpenProperty={openProperty} />);
      return;
    }
    const Comp = PAGE_COMPONENTS[btn.page];
    if (!Comp) { alert(`صفحه "${btn.label}" در حال توسعه است`); return; }
    openTab(`tadarokat:${btn.page}`, btn.label, btn.icon,
      () => <Comp user={user} onBack={goHome} />);
  };

  // دکمه‌های تب — دکمهٔ بی‌مجوز غیرفعال (خاکستری) دیده می‌شود
  const menu = useVbMenu();
  const allowedBtns = TADAROKAT_BUTTONS.map(btn => ({
    ...btn, _on: tabButtonOn(menu, 'TBTADAROKAT', btn.vb || btn.key),
  }));
  const enabledCount = allowedBtns.filter(b => b._on).length;

  const gridResponsiveCSS = `@media(max-width:640px){.arjan-acc-grid{grid-template-columns:repeat(2,1fr)!important;gap:16px!important;max-width:360px;margin:0 auto;padding:0 12px;}}`;

  return (
    <><style>{gridResponsiveCSS}</style>
    <div style={s.page}>
      <header style={s.header}>
        <div style={s.hLeft}>
          <button onClick={onBack} style={s.backBtn}>← بازگشت</button>
          <div style={s.hLogo}><img src={require('../assets/images/arjan.png')} alt="ارجان" style={{width:'36px',height:'36px',borderRadius:'8px'}}/></div>
          <div><div style={s.hTitle}>سامانه ارجان</div><div style={s.hSub}>بخش تدارکات</div></div>
        </div>
        <span style={s.userName}>{user?.full_name}</span>
      </header>
      <TabBar/>
      <main style={s.main}>
        <div style={s.hero}><div style={s.heroIcon}>📦</div><div><h2 style={s.heroTitle}>تدارکات</h2><p style={s.heroSub}>{enabledCount} مورد در دسترس شما</p></div></div>
        {enabledCount > 0 || allowedBtns.length > 0 ? (
          <div className="arjan-acc-grid" style={s.grid}>
            {allowedBtns.map(btn => (
              <div key={btn.key} style={s.btnWrap}>
                <button disabled={!btn._on} style={{...s.btn,background:btn.bg,...(btn._on?{}:DISABLED)}} onClick={()=>btn._on&&openSubPage(btn)}
                  onMouseEnter={e=>{if(!btn._on)return;e.currentTarget.style.transform='translateY(-8px) scale(1.05)';e.currentTarget.style.boxShadow='0 16px 40px rgba(0,0,0,0.35)';}}
                  onMouseLeave={e=>{e.currentTarget.style.transform='translateY(0) scale(1)';e.currentTarget.style.boxShadow='0 8px 24px rgba(0,0,0,0.2)';}}>
                  <span style={s.btnIcon}>{btn.icon}</span>
                </button>
                <div style={s.btnLabel}>{btn.label}</div>
              </div>
            ))}
          </div>
        ) : (<div style={s.noAccess}><div style={{fontSize:'56px',marginBottom:'16px'}}>🔒</div><div style={{fontSize:'16px',color:'#666'}}>دسترسی به این بخش تعریف نشده است</div></div>)}
      </main>
    </div></>
  );
}

/* استایل‌ها — یک‌دست با بخش بودجه و قراردادها */
const s = {
  page:{minHeight:'100vh',background:'#f0f2f7',fontFamily:"'Vazirmatn',Tahoma,sans-serif",direction:'rtl'},
  header:{background:'linear-gradient(135deg,#0a1628,#1a2f50)',padding:'12px 24px',display:'flex',justifyContent:'space-between',alignItems:'center',boxShadow:'0 2px 16px rgba(0,0,0,0.3)',position:'sticky',top:0,zIndex:100},
  hLeft:{display:'flex',alignItems:'center',gap:'12px'},
  backBtn:{padding:'6px 14px',background:'rgba(255,255,255,0.12)',color:'#fff',border:'1px solid rgba(255,255,255,0.25)',borderRadius:'7px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px'},
  hLogo:{width:'40px',height:'40px',background:'rgba(200,168,75,0.12)',border:'1px solid rgba(200,168,75,0.3)',borderRadius:'9px',display:'flex',alignItems:'center',justifyContent:'center'},
  hTitle:{fontSize:'16px',fontWeight:'700',color:'#fff'},
  hSub:{fontSize:'11px',color:'rgba(255,255,255,0.55)'},
  userName:{fontSize:'13px',color:'rgba(255,255,255,0.85)'},
  main:{padding:'32px 24px',maxWidth:'1100px',margin:'0 auto'},
  hero:{display:'flex',alignItems:'center',gap:'16px',marginBottom:'32px'},
  heroIcon:{fontSize:'40px'},
  heroTitle:{fontSize:'22px',fontWeight:'800',color:'#1a2f50',margin:0},
  heroSub:{fontSize:'13px',color:'#888',margin:'4px 0 0'},
  grid:{display:'grid',gridTemplateColumns:'repeat(4,160px)',gap:'24px',justifyContent:'center'},
  btnWrap:{display:'flex',flexDirection:'column',alignItems:'center',gap:'10px'},
  btn:{width:'100%',aspectRatio:'1',border:'none',borderRadius:'20px',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',boxShadow:'0 8px 24px rgba(0,0,0,0.2)',transition:'all .25s'},
  btnIcon:{fontSize:'36px'},
  btnLabel:{fontSize:'13px',fontWeight:'700',color:'#333',textAlign:'center'},
  noAccess:{textAlign:'center',padding:'60px 20px'},
};

// دکمهٔ تبِ بی‌مجوز: دیده می‌شود ولی کار نمی‌کند
const DISABLED = { filter: 'grayscale(1)', opacity: 0.45, cursor: 'not-allowed', boxShadow: 'none' };
